<!--suppress CssUnresolvedCustomProperty -->
<script lang="ts">
    import cssVars from 'svelte-css-vars';
    import {Icon, Modal} from 'svelma';
    import Occasion from "../application/models/Occasion.ts";
    import Manager from "../application/models/Manager.ts";
    import CardModal from "../presentationals/modals/CardModal.svelte";
    import {createEventDispatcher} from "svelte";
    import TypeElement from "../presentationals/TypeElement.svelte";

    export let cardData: Occasion;
    export let position: number;
    export let manager: Manager;
    export let focus: boolean;

    let hovered = false;
    let infoHovered = false;
    let calcTime = manager.dateManager.calculateTimeFromBlockNumber;

    const dispatch = createEventDispatcher();

    $: styleVars = {
        offset: (position * 5) + 'px',
        height: ((cardData.endBlock - cardData.startBlock) * 25) + 'px',
        opacity: (1 - (position * 0.3)),
        zIndex: 10 - position,
        hoverHeight: ((cardData.endBlock - cardData.startBlock) * 25) > 150 ? ((cardData.endBlock - cardData.startBlock) * 25) + 'px' : 150 + 'px'
    }

    function modalOpen(event) {
        dispatch('modalOpen', {
            type: 'card',
            data: cardData
        });
    }
</script>

<div class="card abs scale opacity"
     use:cssVars={styleVars}
     on:mouseenter={()=>hovered=true}
     on:mouseleave={()=>hovered=false}
     class:hovered={hovered && focus}>
    <div class="cardGrid">
        <div class="has-background-primary has-text-white has-text-weight-bold">
            {calcTime(cardData.startBlock)}
        </div>
        <div class="lineGrid">
            <div class="is-size-7">{calcTime(cardData.startBlock)}-{calcTime(cardData.endBlock)}</div>
            <div class="has-text-primary-dark is-size-7 has-text-weight-bold">{cardData.classroom}</div>
        </div>
        {#if cardData.course.subject !== null && focus && cardData.course.subject !== undefined}
            <div class="has-text-info-dark is-size-6 name">{cardData.course.subject.name}</div>
            <div class="is-size-7 has-text-grey-dark"><TypeElement type={cardData.course.type}/></div>
            <div class="lineGrid"
                 class:hide={((cardData.endBlock - cardData.startBlock) * 25)<=150 && !hovered && focus}>
                <div class="has-text-grey-dark is-size-7">{cardData.course.subject.code}</div>
                <div class="has-text-primary-dark info"
                     class:opacityUp={infoHovered===true && focus}
                     on:mouseenter={()=>infoHovered=true}
                     on:mouseleave={()=>infoHovered=false}
                     on:click={modalOpen}>
                    <Icon pack="fa" size="is-medium" icon="info-circle"/>
                </div>
            </div>
        {/if}
    </div>
</div>

<style>

    .opacity {
        opacity: var(--opacity);
    }

    .hide {
        display: none !important;
    }

    .opacityUp {
        opacity: 1 !important;
    }

    .info {
        opacity: 0.3;
    }

    .info:hover {
        cursor: pointer;
    }

    .hovered {
        z-index: 30 !important;
        transform: scale(1.05);
        transition: all ease-in 0.06s;
        height: var(--hoverHeight) !important;
        box-shadow: 0px 6px 20px 3px rgba(0,0,0,0.1);
    }

    .cardGrid {
        min-height: 100%;
        max-height: 100%;
        display: grid;
        grid-template-rows: 20px auto auto auto;
        align-items: center;
        overflow: hidden;
    }

    .lineGrid {
        display: grid;
        grid-template-columns: auto auto;
    }

    .scale {
        height: var(--height);
        min-width: 100%;
        max-width: 100%;
        z-index: var(--zIndex);
    }

    .abs {
        position: absolute;
        top: var(--offset);
        left: var(--offset);
    }

    @media screen and (max-width: 1100px){
        .name{
            font-size: 14px!important;
        }
    }
</style>